export default __webpack_public_path__ + "static/media/twilio.48e8f7ca.jpg";